import React, { useEffect, useState } from "react";
import "./Hospitals.css";
import data from "./Hospitals.json";
import { CDN_BASE_URL, cdnUrl } from "../../config/cdn";

const defaultTheme = {
  primary: "#0D746E",
  panel: "#0F6B5E",
  accent: "#00C4B8",
  lightPanel: "#E6F7F5",
  textDark: "#053936",
};

// const img = (path) => `${CDN_BASE_URL}/images/${path}`;


/* ========================= CONTACT POPUP ========================= */
const ContactPopup = ({ open, onClose, pageName }) => {
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    hospital: "",
    facilityType: "",
    query: "",
  });

  if (!open) return null;

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("http://localhost:5000/submit-form", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ pageName, ...formData }),
      });

      const result = await response.json();
      if (result.success) {
        setSubmitted(true);
        setTimeout(() => setSubmitted(false), 2000);
        onClose();
      }
    } catch (err) {
      console.error("Error submitting:", err);
    }
  };

  return (
    <>
      <div className="modal-overlay">
        <div className="modal-box">
          <h3>Contact Us</h3>

          <form onSubmit={handleSubmit}>
            <label>Name *</label>
            <input name="name" required onChange={handleChange} />

            <label>Email *</label>
            <input type="email" name="email" required onChange={handleChange} />

            <label>Phone</label>
            <input name="phone" onChange={handleChange} />

            <label>Hospital</label>
            <input name="hospital" onChange={handleChange} />

            <label>Facility Type *</label>
            <select name="facilityType" required onChange={handleChange}>
              <option value="">Select a facility type</option>
              <option>Hospitals</option>
              <option>Group Practice</option>
              <option>Individual Provider</option>
            </select>

            <label>Query</label>
            <textarea name="query" rows={4} onChange={handleChange}></textarea>

            <button type="submit" className="submit-btn">
              Schedule my demo
            </button>
          </form>

          <button className="close-btn" onClick={onClose}>✕</button>
        </div>
      </div>

      {submitted && <div className="success-popup">Our specialist will contact you soon.</div>}
    </>
  );
};

/* ========================= HERO SECTION ========================= */
const Hero = () => {
  const background = cdnUrl(data.hero.background);


  return (
    <header
      className="h-hero"
      style={{ backgroundImage: `url(${background})` }}
    >
      <div className="h-hero-overlay"></div>
      <div className="h-hero-inner">
        <div className="h-hero-left">
          <h3 className="eyebrow">{data.hero.eyebrow}</h3>
          <h1 dangerouslySetInnerHTML={{ __html: data.hero.title }} />
        </div>
      </div>
    </header>
  );
};


/* ========================= PANEL BELOW HERO ========================= */
const HeroPanel = ({ openPopup }) => (
  <section className="h-panel">
    <div className="h-panel-inner">
      <div className="h-panel-left">
        <h2 className="panel-title">{data.heroPanel.title}</h2>
      </div>

      <div className="h-panel-right">
        <p className="panel-desc">{data.heroPanel.description}</p>

        <button className="btn solid" onClick={openPopup}>
          {data.heroPanel.button}
        </button>
      </div>
    </div>
  </section>
);

/* ========================= OFFERINGS ========================= */
const OfferCard = ({ icon, title, desc }) => (
  <div className="offer-card">
    <img
      src={`${CDN_BASE_URL}/images/${icon}`}
      alt={title}
      className="offer-icon"
    />
    <h4 className="offer-title">{title}</h4>
    <p className="offer-desc">{desc}</p>
  </div>
);

const Offerings = ({ openPopup }) => (
  <section className="h-offerings">
    <div className="h-offerings-wrapper">
      <div className="offerings-left">
        <h2>{data.offerings.title}</h2>
        <p>{data.offerings.subtitle}</p>
        <button className="btn offerings-btn" onClick={openPopup}>
          {data.offerings.button}
        </button>
      </div>

      <div className="offerings-right">
        <img
          src={`${CDN_BASE_URL}/images/${data.offerings.image}`}
          alt="Hospitals"
          className="offerings-img"
        />
      </div>
    </div>

    <div className="offer-grid">
      {data.offerings.cards.map((c, i) => (
        <OfferCard
          key={i}
          icon={c.icon}
          title={c.title}
          desc={c.desc}
        />
      ))}
    </div>
  </section>
);

/* ========================= OUTCOMES ========================= */
const Outcomes = () => (
  <section className="h-outcomes">
    <div className="h-outcomes-inner">
      <h2 className="section-title">{data.outcomes.title}</h2>
      <p className="section-subtext">{data.outcomes.subtitle}</p>

      <div className="outcome-big-card">
        <div className="outcome-columns">
          {data.outcomes.stats.map((stat, i) => (
            <div className="outcome-value" key={i}>
              <h3>{stat.value}</h3>
              <span>{stat.label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

/* ========================= TESTIMONIALS ========================= */
const Testimonials = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setIndex((i) => (i + 1) % data.testimonials.items.length);
    }, 5000);
    return () => clearInterval(id);
  }, []);

  const current = data.testimonials.items[index];

  return (
    <section className="h-testimonials">
      <h2 className="section-title" style={{ textAlign: "center" }}>
        {data.testimonials.title}
      </h2>

      <div className="test-card">
        <p className="quote">“{current.quote}”</p>
        <div className="author">{current.author}</div>

        <div className="dots">
          {data.testimonials.items.map((_, i) => (
            <span key={i} className={i === index ? "dot active" : "dot"}></span>
          ))}
        </div>
      </div>
    </section>
  );
};

/* ========================= CONTACT FORM ========================= */
const ContactForm = ({ openPopup }) => (
  <section className="h-contact">
    <div className="h-contact-inner">
      <div className="h-contact-left">
        <h3>{data.contact.title}</h3>
      </div>

      <form className="contact-form" onSubmit={(e) => { e.preventDefault(); openPopup(); }}>
        <input placeholder="Name *" required />
        <input placeholder="Email *" type="email" required />
        <input placeholder="Phone" />
        <button className="btn solid">{data.contact.button}</button>
      </form>
    </div>
  </section>
);

/* ========================= MAIN PAGE ========================= */
const Hospitals = ({ initialTheme = defaultTheme }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="h-page" style={{ color: defaultTheme.textDark }}>
      <Hero />
      <HeroPanel openPopup={() => setOpen(true)} />
      <Offerings openPopup={() => setOpen(true)} />
      <Outcomes />
      <Testimonials />
      <ContactForm openPopup={() => setOpen(true)} />

      <ContactPopup open={open} onClose={() => setOpen(false)} pageName="Hospitals Page" />
    </div>
  );
};

export default Hospitals;
